/* tslint:disable */
/* eslint-disable */
/**
 * referral-network
 * referral-network
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListDirectoryContacts200Response,
} from '../models/index';
import {
    ListDirectoryContacts200ResponseFromJSON,
    ListDirectoryContacts200ResponseToJSON,
} from '../models/index';

export interface ListDirectoryContactsRequest {
    senderFacilityId: number;
    providerId: string;
    contactType: ListDirectoryContactsContactTypeEnum;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * List a provider\'s directory contacts of a given type for the recipient contact picker
     */
    async listDirectoryContactsRaw(requestParameters: ListDirectoryContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDirectoryContacts200Response>> {
        if (requestParameters.senderFacilityId === null || requestParameters.senderFacilityId === undefined) {
            throw new runtime.RequiredError('senderFacilityId','Required parameter requestParameters.senderFacilityId was null or undefined when calling listDirectoryContacts.');
        }

        if (requestParameters.providerId === null || requestParameters.providerId === undefined) {
            throw new runtime.RequiredError('providerId','Required parameter requestParameters.providerId was null or undefined when calling listDirectoryContacts.');
        }

        if (requestParameters.contactType === null || requestParameters.contactType === undefined) {
            throw new runtime.RequiredError('contactType','Required parameter requestParameters.contactType was null or undefined when calling listDirectoryContacts.');
        }

        const queryParameters: any = {};

        if (requestParameters.senderFacilityId !== undefined) {
            queryParameters['sender_facility_id'] = requestParameters.senderFacilityId;
        }

        if (requestParameters.providerId !== undefined) {
            queryParameters['provider_id'] = requestParameters.providerId;
        }

        if (requestParameters.contactType !== undefined) {
            queryParameters['contact_type'] = requestParameters.contactType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/referral-recipient-configs/contacts`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDirectoryContacts200ResponseFromJSON(jsonValue));
    }

    /**
     * List a provider\'s directory contacts of a given type for the recipient contact picker
     */
    async listDirectoryContacts(requestParameters: ListDirectoryContactsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDirectoryContacts200Response> {
        const response = await this.listDirectoryContactsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListDirectoryContactsContactTypeEnum = {
    Inbound: 'inbound',
    Outbound: 'outbound'
} as const;
export type ListDirectoryContactsContactTypeEnum = typeof ListDirectoryContactsContactTypeEnum[keyof typeof ListDirectoryContactsContactTypeEnum];
